import { IReviewToggleArgs } from "./ireview-toggle-args.interface";
import { IToggleResult } from "./itoggle-result.interface";
import { ReviewApprovalStatus } from "../review-approval/review-approval-status.type";
import {
  NOT_READY_FOR_REVIEW,
  READY_FOR_REVIEW,
  REVIEW_APPROVED,
  REVIEW_NEEDS_UPDATING,
} from "../../utils/constants";
import { IDropdownValue } from "../../utils/helpers";

export const getReviewToggleValues = (
  args: IReviewToggleArgs
): IToggleResult<ReviewApprovalStatus> => {
  if (isNotReadyForReview(args)) {
    return notReadyForReview();
  }

  switch (getReviewStageStatus(args)) {
    case "not_ready_for_review":
      return notReadyForReview();

    case "ready_for_review":
      return createToggleResult(getDisabledStatus(args), [
        READY_FOR_REVIEW,
        REVIEW_NEEDS_UPDATING,
        REVIEW_APPROVED,
      ]);

    case "needs_updating":
      return createToggleResult(getDisabledStatus(args), [REVIEW_NEEDS_UPDATING, READY_FOR_REVIEW]);

    case "approved":
      return createToggleResult(true, [REVIEW_APPROVED]);
  }
};

function getReviewStageStatus(args: IReviewToggleArgs) {
  return args.stage.status;
}

function getReviewerId(args: IReviewToggleArgs) {
  return args.stage.reviewer.id;
}

function isNotReadyForReview(args: IReviewToggleArgs): boolean {
  return (
    args.parentApprovalStatus === "draft" ||
    args.status === "draft" ||
    args.status === "work_can_start" ||
    !args.currentUserId ||
    !args.briefOwnerId
  );
}

function createToggleResult(
  disabled: boolean,
  dropdownValues: IDropdownValue<ReviewApprovalStatus>[]
): IToggleResult<ReviewApprovalStatus> {
  return {
    disabled,
    dropdownValues,
  };
}

function notReadyForReview(): IToggleResult<ReviewApprovalStatus> {
  return createToggleResult(true, [NOT_READY_FOR_REVIEW]);
}

function isCurrentUserReviewer(args: IReviewToggleArgs) {
  return args.currentUserId === getReviewerId(args);
}

function getDisabledStatus(args: IReviewToggleArgs): boolean {
  return !(isCurrentUserReviewer(args) || args.canUpdateStatus);
}
